const routes = [
    {
        path: '/farmacias',
        name: 'farmaciasFo',
        props: true,
        meta: { requiresAuth: true, vista: 'farmaciasFo' },
        component: () => import('@/components/admin/farmacia/index.vue'),
    },
    {
        path: '/admin',
        name: 'admin',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('../views/admin/index.vue'),
         children: [
            // {
            //     path: 'inicio',
            //     name: 'inicio',
            //     component: () => import(/* webpackChunkName: "about" */ '../views/InicioView.vue'),
            // },
            // {
            //     path: 'carga',
            //     name: 'carga',
            //     component: () => import(/* webpackChunkName: "about" */ '../views/CargaView.vue'),
            // },
            // {
            //     path: 'usuarios',
            //     name: 'usuarios',
            //     component: () => import(/* webpackChunkName: "about" */ '../views/UsuariosView.vue'),
            // },
            // {
            //     path: 'imagenes',
            //     name: 'imagenes',
            //     component: () => import(/* webpackChunkName: "about" */ '../views/ImagenesView.vue'),
            // },
            // {
            //     path: 'mesas',
            //     name: 'mesas',
            //     component: () => import(/* webpackChunkName: "about" */ '../views/MesasView.vue'),
            // },
            // {
            //     path: 'agrupaciones',
            //     name: 'agrupaciones',
            //     component: () => import(/* webpackChunkName: "about" */ '../views/AgrupacionesView.vue'),
            // },
            // {
            //     path: 'candidatos',
            //     name: 'candidatos',
            //     component: () => import(/* webpackChunkName: "about" */ '../views/CandidatosView.vue'),
            // },

            // {
            //     path: 'config',
            //     name: 'config',
            //     component: () => import(/* webpackChunkName: "about" */ '../views/ConfigView.vue'),
            // }
            // //config
        ]
    },
]

export default routes